import { render, staticRenderFns } from "./StoreManage.vue?vue&type=template&id=f5d711b0&scoped=true&"
import script from "./StoreManage.vue?vue&type=script&lang=js&"
export * from "./StoreManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d711b0",
  null
  
)

export default component.exports